var _dec, _class;
import React, { Component } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import compose from 'lodash.flowright';
import { inject, observer } from 'mobx-react';
import { Link, withRouter } from 'react-router-dom';
import { Badge } from '@winnin/winnin_ui.components.badge';
import { Card } from '@winnin/winnin_ui.components.card';
import { Icon } from '@winnin/winnin_ui.components.icon';
import { Loading } from '@winnin/winnin_ui.components.loading';
import { Title } from '@winnin/winnin_ui.components.title';
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper';
import AddVideoToCheckBox from 'components/AddVideoToCheckbox';
import BioCard from 'components/BioCard';
import { ChartCardMonoMetric } from 'components/ChartCardMonoMetric';
import LivePostTag from 'components/LivePostTag';
import MetricsCard from 'components/MetricsCard';
import TagCloud from 'components/TagCloud';
import VideoCard from 'components/VideoCard';
import { COLORS } from 'consts';
import { PostInformationFragment } from 'fragments/SearchPostsFragments';
import withAuth from 'HOC/withAuth';
import { client } from 'lib/apollo-client';
import { withTolgee, T } from 'lib/tolgee';
import { VideoInfo } from 'modules/posts';
import { isBrandComponentHidden } from 'modules/winnin-lite/common/winnin-lite.utils';
import ErrorUnauthorized from 'pages/ErrorPage/errors/eUnauthorized';
import { PanelStore, UserStore, FeatureFlagsStore } from 'stores';
import { TOLGEE_GLOBALS } from 'utils';
import analyticsTracker from 'utils/analyticsTracker';
import { getTerritoryLinkByType } from 'utils/territoryUtils';
import LiveGraphs from './components/LiveGraphs';
import VideoEmbed from './components/VideoEmbed';
import { MODAL_VIDEO_QUERY, SAME_CREATOR_VIDEOS_QUERY, SAME_TOPIC_VIDEOS_QUERY, THIRTY_DAY_VIDEO_PERFORMANCE, VIDEO_PERFORMANCE } from './query.js';
import './index.scss';
const {
  VIDEO_VIEW,
  PAGE_VIEW
} = analyticsTracker.eventNames;
dayjs.extend(duration);
let VideoContent = (_dec = inject('VideoModalStore', 'routingStore', 'UserStore', 'FeatureFlagsStore', 'PanelStore'), _dec(_class = observer(_class = class VideoContent extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      descriptionExpanded: false,
      video: null,
      videoParams: null,
      isLoadingVideo: true,
      sameCreatorVideos: {
        items: [],
        loading: true
      },
      sameTopicVideos: {
        items: [],
        loading: true
      }
    };
    this.getSameCreatorVideos = currentVideo => {
      const {
        creatorId,
        provider,
        creator
      } = this.state.video;
      if (creator?.__typename.startsWith('CreatorIncomplete')) {
        this.setState({
          sameCreatorVideos: {
            items: [],
            loading: false
          }
        });
        return;
      }
      const {
        minimalVersion
      } = this.props;
      if (minimalVersion) {
        return;
      }
      client.query({
        query: SAME_CREATOR_VIDEOS_QUERY,
        variables: {
          id: creatorId,
          provider: provider,
          fetchPolicy: 'no-cache'
        }
      }).then(({
        data
      }) => {
        const videos = data.creators[0].posts;
        const videosWithoutCurrentVideo = videos.filter(item => item.postId !== currentVideo.postId);
        if (videosWithoutCurrentVideo.length === 4) {
          videosWithoutCurrentVideo.pop();
        }
        this.setState({
          sameCreatorVideos: {
            items: videosWithoutCurrentVideo,
            loading: false
          }
        });
      }).catch(e => {
        console.error('VideoModalContent@getSameCreatorVideos >>>>>>>>>>>', e);
        this.setState({
          sameCreatorVideos: {
            items: [],
            loading: false
          }
        });
      });
    };
    this.getSameTopicVideos = async currentVideo => {
      const {
        queryContext
      } = this.props;
      const {
        topics
      } = this.state.video;
      const topicIds = topics?.length ? topics.map(topic => topic.topicId) : [];
      const {
        minimalVersion
      } = this.props;
      if (minimalVersion) {
        return;
      }
      try {
        const publishedAt = {
          gt: dayjs(dayjs().subtract(3, 'month')).valueOf()
        };
        const {
          data
        } = await client.query({
          query: SAME_TOPIC_VIDEOS_QUERY,
          variables: {
            topicIds,
            gt: publishedAt.gt
          },
          context: queryContext
        });
        const videos = data?.searchPosts?.entities;
        const videosWithoutCurrentVideo = videos.filter(item => item.postId !== currentVideo.postId);
        if (videosWithoutCurrentVideo.length === 4) videosWithoutCurrentVideo.pop();
        this.setState({
          sameTopicVideos: {
            items: videosWithoutCurrentVideo,
            loading: false
          }
        });
      } catch (e) {
        console.error('VideoModalContent@getSameTopicVideos >>>>>>>>>>>', e);
        this.setState({
          sameTopicVideos: {
            items: [],
            loading: false
          }
        });
      }
    };
    this.videoExtractor = data => data.posts[0].performance;
    this.handleOnClickPrevious = () => {
      this.props.VideoModalStore.loadPreviousVideo();
    };
    this.handleOnClickNext = () => {
      this.props.VideoModalStore.loadNextVideo();
    };
    this.handleVideoClick = currentVideo => {
      const {
        routingStore,
        VideoModalStore
      } = this.props;
      const formattedCurrentVideo = {
        postId: currentVideo.postId,
        provider: currentVideo.provider
      };
      if (!routingStore?.history?.location?.state?.backgroundPage) {
        this.setState({
          videoParams: {
            postId: currentVideo.postId,
            provider: currentVideo.provider
          }
        }, () => this.handleLoadVideoData(this.state.videoParams));
        return VideoModalStore.setVideo({
          currentVideo: formattedCurrentVideo
        });
      }
      VideoModalStore.setVideo({
        currentVideo: formattedCurrentVideo,
        changeBackground: false
      });
    };
    this.handleClickTopic = () => {
      const isModalOpen = !!this.props.VideoModalStore.currentVideo;
      if (isModalOpen) this.props.VideoModalStore.clearVideo();
    };
  }
  componentDidMount() {
    const {
      routingStore
    } = this.props;
    if (!routingStore?.history?.location?.state?.backgroundPage) {
      this.handleVideoURL();
    } else {
      this.handleLoadVideoData(this.props.video);
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.video?.postId && prevProps.video.postId !== this.props.video.postId) {
      this.handleLoadVideoData(this.props.video);
    }
  }
  handleVideoURL() {
    const {
      VideoModalStore,
      match
    } = this.props;
    VideoModalStore.setVideo({
      currentVideo: {
        postId: match.params.postId,
        provider: match.params.provider
      }
    });
    this.setState({
      videoParams: {
        postId: match.params.postId,
        provider: match.params.provider
      }
    }, () => this.handleLoadVideoData(this.state.videoParams));
  }
  trackPageView() {
    const macroAreas = {
      panel: 'Home',
      search: 'Video',
      group: 'Creator',
      topic: 'Topic',
      'industry-category': 'Industry Category'
    };
    const {
      location,
      isVideoPage
    } = this.props;
    const splittedPathname = location?.state?.backgroundPage?.pathname?.split('/') ?? [];
    const currentMacroArea = macroAreas[splittedPathname[1]] || macroAreas[splittedPathname[3]];
    const tabTitle = splittedPathname[5];
    analyticsTracker.eventTrack(this.props.isVideoPage ? PAGE_VIEW : VIDEO_VIEW, {
      'Macro Area': currentMacroArea ?? 'Video',
      'Video Title': this.state.video.title,
      'Page Name': isVideoPage ? 'Video Page' : 'Video Modal',
      ...(currentMacroArea === 'Creator' && {
        'Tab Title': tabTitle
      })
    });
  }
  async handleLoadVideoData(video) {
    const {
      postId,
      provider
    } = video;
    let post = client.readFragment({
      id: `Post:${provider}:${postId}`,
      fragment: PostInformationFragment,
      fragmentName: 'PostInformationFull'
    });
    if (!post) {
      this.setState({
        isLoadingVideo: true
      });
      const queryResult = await client.query({
        query: MODAL_VIDEO_QUERY,
        variables: {
          _id: `${provider}:${postId}`
        }
      }).catch(e => {
        console.error('VideoModalContent@loadVideoData >>>>>>>>>>>', e);
        this.setState({
          isLoadingVideo: false
        });
      });
      post = queryResult?.data?.post;
    }
    if (!post) {
      return this.props.history.push('/404');
    }
    this.setState({
      video: post,
      isLoadingVideo: false
    }, () => {
      this.getSameCreatorVideos(video);
      if (post?.topics && post.topics.length > 0) {
        this.getSameTopicVideos(video);
      } else {
        this.setState({
          sameTopicVideos: {
            items: [],
            loading: false
          }
        });
      }
      this.trackPageView();
    });
  }
  render() {
    const {
      isLoadingVideo
    } = this.state;
    if (isLoadingVideo) {
      return <Loading className="VideoModalContentLoading" showMessage={true} />;
    }
    const {
      sameCreatorVideos,
      sameTopicVideos,
      video
    } = this.state;
    const {
      minimalVersion,
      t
    } = this.props;
    const {
      engagement,
      provider,
      videoUrl,
      views,
      title,
      comments,
      description,
      likes,
      publishedAt,
      tags,
      territories,
      engagementRatio,
      postId,
      postUrl,
      creatorId,
      thumbnail,
      creator,
      live,
      isPublicity,
      productType,
      hasViewsReaction,
      hasCommentsReaction,
      hasLikesReaction,
      isLikesReactionDisabled
    } = video || {};
    const allConcurrentViewers = live?.performance?.map(value => value.concurrentViewers)?.filter(i => i !== null && i !== undefined) ?? [];
    const maxConcurrentViewers = Math.max(...allConcurrentViewers);
    const videoMetrics = {
      likes,
      description,
      publishedAt,
      comments,
      views,
      engagement,
      engagementRatio,
      live,
      maxConcurrentViewers,
      info: {
        hasViewsReaction,
        hasLikesReaction,
        isLikesReactionDisabled,
        hasCommentsReaction
      }
    };
    const videoVariables = {
      postsInfo: {
        id: postId,
        provider
      }
    };
    const {
      VideoModalStore,
      history,
      match,
      auth
    } = this.props;
    const verifyViews = provider === 'fb';
    const shouldNotDisplayCharts = provider === 'tt' || live?.state === 'inProgress';
    const usersProviders = UserStore.providers;
    const currentProvider = match.params.provider;
    const userHasAccess = usersProviders.includes(currentProvider);
    const isUserAuthenticated = auth?.keycloak?.authenticated;
    const canSee = userHasAccess || !isUserAuthenticated;
    const isSingleCreatorCompareEnabled = FeatureFlagsStore.isFeatureFlagEnabled('isSingleCreatorCompareEnabled');
    if (!canSee) {
      return <div className="VideoModalContent">
          <ErrorUnauthorized history={history} />
        </div>;
    }
    return <div className="VideoModalContent">
        {VideoModalStore.previousVideo !== null ? <div onClick={this.handleOnClickPrevious} className="modal-arrow arrow-previous">
            <Icon fill={COLORS.gray} icon="arrowLeft" width={24} height={24} />
            <span>
              <T keyName="VideoContent-controlPrevious">previous</T>
            </span>
          </div> : null}

        {VideoModalStore.nextVideo !== null ? <div onClick={this.handleOnClickNext} className="modal-arrow arrow-next">
            <span>
              <T keyName="VideoContent-controlNext">next</T>
            </span>
            <Icon fill={COLORS.gray} icon="arrowRight" width={24} height={24} />
          </div> : null}

        <div className="modal-content">
          <div className="video-modal-container">
            <VideoEmbed creatorId={creatorId} postId={postId} postUrl={postUrl} provider={provider} thumbnail={thumbnail} title={title} videoUrl={videoUrl} creator={creator} live={live} productType={productType} />

            <div className="video-modal-content">
              <div className="info-content-grid">
                <Card className="video-info">
                  <div className="video-info-addto-title video-info-addto-title-with-checkbox">
                    {!minimalVersion && !isBrandComponentHidden('videoSelect') && <AddVideoToCheckBox id={postId} provider={provider} creatorName={creator?.title} thumbnail={thumbnail} title={title} isModal />}
                    <Title tag="h3" className="title">
                      {title}
                    </Title>
                  </div>

                  <div className="content">
                    <VideoInfo video={video} />
                  </div>
                </Card>

                {(territories?.length || provider === 'in') && <Card className="topics-post-link-container">
                    {territories && !!territories.length && <div className="topics-content">
                        <Title tag="h5" weight="regular" className="header title">
                          <T keyName="VideoContent-labelTopics">Topics</T>:
                        </Title>

                        <div className="content video-related-topics">
                          {territories.map((territory, index) => {
                      const separator = index === territories.length - 1 ? ' ' : ', ';
                      if (isBrandComponentHidden('videoModalTopic')) {
                        return <span className="video-related-topics" key={`${territory.territoryId}-${index}`}>
                                  {territory.name}
                                  {separator}
                                </span>;
                      }
                      const workspaceId = PanelStore?.selectedPanel?.panelId;
                      const territoryId = territory.territoryId;
                      const type = territoryId.split('.')[0];
                      const id = territoryId.split('.')[1];
                      const territoryUrl = getTerritoryLinkByType(type, id, workspaceId);
                      const topicRoute = workspaceId ? territoryUrl : '#';
                      return <Link className="video-related-topics" onClick={this.handleClickTopic} key={`${territory.territoryId}-${index}`} to={topicRoute}>
                                {territory.name}
                                {separator}
                              </Link>;
                    })}
                        </div>
                      </div>}

                    {provider === 'in' && <Link className="post-link" to={postUrl} rel="noopener noreferrer" target="_blank">
                        <T keyName="VideoConten-watchOnInstagram">Watch video on Instagram</T>
                      </Link>}
                  </Card>}
                <div className="live-ads-wrapper">
                  {isPublicity && <TooltipWrapper tooltipMessage={t(TOLGEE_GLOBALS.paidPartnership)} tooltipStyle="tooltippedE">
                      <Badge colorScheme="yellow" className="YellowBadge-customStyle">
                        <Icon icon="ads" fill="var(--base_color1)" width={11} height={16} />
                      </Badge>
                    </TooltipWrapper>}
                  {live && <Card className="live-state">
                      <LivePostTag live={live} isCard={false} />
                    </Card>}
                </div>

                <MetricsCard metrics={videoMetrics} provider={provider} loading={!publishedAt} className="video-modal-about" />

                <LiveGraphs provider={provider} live={live} />

                {provider === 'yt' && description?.length > 0 && <BioCard content={description} loading={false} />}

                {tags && !!tags.length && <div className="video-modal-tag-cloud-card title-content">
                    <Title tag="h3" className="title">
                      <T keyName="VideoContent-labelTags">Tags</T>
                    </Title>

                    <Card className="content">
                      <TagCloud tags={tags} showIndex={false} limit={20} onTagClick={() => {}} showExtraTags />
                    </Card>
                  </div>}

                {!minimalVersion && <>
                    {!shouldNotDisplayCharts && !isSingleCreatorCompareEnabled && <>
                        <div className="chart-side-by-side">
                          <ChartCardMonoMetric cumulative daily performanceExtractor={data => data.posts[0].performance30Days} publishedAt={publishedAt} query={THIRTY_DAY_VIDEO_PERFORMANCE} sortBy="views" sortByLabel="Views" title={t(TOLGEE_GLOBALS.views)} variables={videoVariables} chartWidth="100%" notHasViews={verifyViews} />

                          <ChartCardMonoMetric cumulative emptyStateText={provider === 'tw' && t(TOLGEE_GLOBALS.platformMetricNotApplicable)} daily performanceExtractor={data => data.posts[0].performance30Days} publishedAt={publishedAt} query={THIRTY_DAY_VIDEO_PERFORMANCE} sortBy="likes" sortByLabel="Likes" title={t(TOLGEE_GLOBALS.likes)} variables={videoVariables} chartWidth="100%" />
                        </div>

                        <div className="chart-side-by-side">
                          <ChartCardMonoMetric cumulative performanceExtractor={this.videoExtractor} query={VIDEO_PERFORMANCE} sortBy="views" sortByLabel={t(TOLGEE_GLOBALS.views)} title={t(TOLGEE_GLOBALS.views)} variables={videoVariables} chartWidth="100%" notHasViews={verifyViews} />

                          <ChartCardMonoMetric cumulative emptyStateText={provider === 'tw' && t(TOLGEE_GLOBALS.platformMetricNotApplicable)} performanceExtractor={this.videoExtractor} query={VIDEO_PERFORMANCE} sortBy="likes" sortByLabel={t(TOLGEE_GLOBALS.likes)} title={t(TOLGEE_GLOBALS.likes)} variables={videoVariables} chartWidth="100%" />
                        </div>
                      </>}

                    {(sameCreatorVideos.loading || sameCreatorVideos.items.length > 0) && <div className="related-videos">
                        <Title tag="h3" className="title">
                          <T keyName="VideoContent-labelSameCreatorVideos">Same Creator Videos</T>
                        </Title>

                        {sameCreatorVideos.loading ? <Loading /> : <div className="related-videos-grid">
                            {sameCreatorVideos.items.map((video, index) => {
                      return <VideoCard onClick={() => this.handleVideoClick(video)} index={index} key={`${video.postId}-${index}`} {...video} />;
                    })}
                          </div>}
                      </div>}

                    {(sameTopicVideos.loading || sameTopicVideos.items.length > 0) && <div className="related-videos">
                        <Title tag="h3" className="title">
                          <T keyName="VideoContent-labelSameTopicVideos">Same Topic Videos</T>
                        </Title>

                        {sameTopicVideos.loading ? <Loading /> : <div className="related-videos-grid">
                            {sameTopicVideos.items.map((video, index) => {
                      return <VideoCard onClick={() => this.handleVideoClick(video)} index={index} key={`${video.postId}-${index}`} {...video} />;
                    })}
                          </div>}
                      </div>}
                  </>}
              </div>
            </div>
          </div>
        </div>
      </div>;
  }
}) || _class) || _class);
const VideoContentWithHOCs = compose([withRouter, withTolgee, withAuth])(VideoContent);
export default VideoContentWithHOCs;